import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M16.17 11l-5.36-5.36 1.41-1.42L20 12l-7.78 7.78-1.41-1.42L16.17 13H4v-2h12.17z"/>
  </SvgIcon>
);